import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'

export default function SmallCards({ data, spacing, width }) {
    return (
        <Box width={width ?? 1} marginX={'auto'}>
            <Grid container spacing={spacing ?? 4}>
                {
                    data?.map((item, index) => (
                        <Grid key={index} size={{ lg: 3, sm: 6, xs: 12 }}>
                            <Grid container spacing={8}>
                                <Grid size={12}>
                                    <Box className='flexCenter'>
                                        <Box component={'img'} src={item.imageUrl} height={1} sx={{ objectFit: 'cover' }} />
                                    </Box>
                                </Grid>
                                <Grid size={12}>
                                    <Typography textAlign={'center'} className='dColor' gutterBottom fontSize={'1.5rem'} variant="h4" fontWeight={'bold'}>{item.title}</Typography>
                                    <Typography textAlign={'center'} className='dColor' fontSize={'1rem'} variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>{item.description}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}